export interface WorkspaceLabelTarget {
  workspace_type?: string
  company_name?: string | null
  name?: string | null
}

/**
 * The name a workspace goes by in the header: the personal workspace by the
 * user's e-mail, a company by its company name. An unverified VAT payer's
 * draft needs no rule of its own: the API already reports it by its VAT ID
 * (`name`) with a blank `company_name`.
 */
export function workspaceDisplayLabel(
  ws: WorkspaceLabelTarget | null | undefined,
  userEmail: string,
): string {
  if (!ws)
    return ''
  if (ws.workspace_type === 'personal')
    return userEmail || ws.name || ''

  return ws.company_name || ws.name || ''
}

/**
 * Label of the account button: who the user is acting as. Until the active
 * workspace has loaded it is the user's e-mail, and `fallback` without one.
 */
export function accountMenuLabel(
  activeWorkspace: WorkspaceLabelTarget | null | undefined,
  userEmail: string,
  fallback: string,
): string {
  return workspaceDisplayLabel(activeWorkspace, userEmail) || userEmail || fallback
}
